import "../existingLandingPage.scss";

import pluralize from "pluralize";
import ShareModal from "../ShareModal";
import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import PrimaryBtn from "../../../../../../../common/Buttons/PrimaryButton";
import { getFullImageUrl } from "../../../../../../../../utils/constants/constants";

const FinalExistingB2cLp = ({
  resData,
  showBackBtn,
  toggleModal,
  loyaltyData,
  currencyView,
}) => {
  const [isCustomShare, toggleCustomShare] = useState(false);

  const b2cData = resData?.referral_settings;
  const isCashbackLoyalty = loyaltyData?.type === "cashback";
  const pointsBranding = loyaltyData?.settings?.points_branding;
  let data = {
    storeName: resData?.store_group_name || "",
    rewardType:
      b2cData?.referring_customer_settings?.referral_bonus?.type || "",
    newCustRewardTitle: getNewCustRewardTitle(
      b2cData?.referred_customer_settings?.reward,
      currencyView
    ),
    text_color: b2cData?.landing_page_settings?.colors?.text || "#ffffff",
    logo: getFullImageUrl(b2cData?.landing_page_settings?.logo) || "",
    theme_color: b2cData?.landing_page_settings?.colors?.theme || "#038C8B",
    landingPageTitle: b2cData?.landing_page_settings?.title|| "",
    minPurchase:
      b2cData.referring_customer_settings?.min_requirements?.bill_amount,
    terms: b2cData.referring_customer_settings?.terms?.filter(
      (term) => term?.status && term?.text?.length > 0
    ),
    referred_short_link_code: resData?.short_link_code,
  };
  
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "Referral",
        text: `I had a great time at ${data.storeName}, I think you will too 😄

Register on this link and get ${data.landingPageTitle} on your first purchase 🎁
        
Click here to register:`,
        url: getReferredShortLink(data.referred_short_link_code),
      });
    } else {
      toggleCustomShare(!isCustomShare);
    }
  };
  
  return (
    <div className="b2c-existing-landing-page">
      <div
        className="upper-div"
        style={{
          color: data.text_color,
          backgroundColor: data.theme_color,
        }}
      >
        {showBackBtn && (
          <PrimaryBtn
            text="Back"
            width="81px"
            height="36px"
            btnColor="#ffffff"
            txtcolor="#282A2C"
            handleClick={toggleModal}
            leftIcon="/assets/icons/arrow-left.svg"
          />
        )}
        <div
          className="card-logo-div"
          style={{
            backgroundColor: data.text_color,
          }}
        >
          {data?.logo ? (
            <img
              width="136px"
              alt="card-logo"
              title={data.storeName}
              className="card-logo-image"
              src={getFullImageUrl(data?.logo)}
            />
          ) : (
            <p className="card-logo-name" style={{ color: data.theme_color }}>
              {data.storeName}
            </p>
          )}
        </div>
        <h4>
          Hi {resData?.customer_name?.split(" ")?.[0]}, Refer {data.storeName}{" "}
          to your friends & get rewards!
        </h4>
      </div>
      <div className="bottom-div">
        <h2>
          Give your friends
          <br />
          <span>{data.newCustRewardTitle}</span>
        </h2>
        <h4>On their first purchase</h4>
        <h2>
          You get
          <br />
          <span>
            {data?.rewardType === "amount_off"
              ? `${currencyView}${b2cData?.referring_customer_settings?.referral_bonus?.value} discount`
              : `${
                  b2cData?.referring_customer_settings?.referral_bonus?.value
                } bonus ${
                  isCashbackLoyalty
                    ? pointsBranding?.active
                      ? pluralize(
                          pointsBranding?.name,
                          b2cData?.referring_customer_settings?.referral_bonus
                            ?.value
                        )?.toLowerCase()
                      : "cash"
                    : pluralize(
                        pointsBranding?.active
                          ? pointsBranding?.name
                          : "points",
                        b2cData?.referring_customer_settings?.referral_bonus
                          ?.value
                      )?.toLowerCase()
                }`}
          </span>
        </h2>
        <h4>For every friend who makes a purchase</h4>
        <PrimaryBtn
          width="100%"
          height="40px"
          handleClick={handleShare}
          text="Share with friends"
          txtcolor={data.text_color}
          btnColor={data.theme_color}
        />
        {data?.terms?.length > 0 && (
          <Accordion className="terms-accordion">
            <Accordion.Item>
              <Accordion.Header>Terms and Conditions</Accordion.Header>
              <Accordion.Body>
                <ul>
                  {data.minPurchase.active && data.minPurchase.amount > 0 && (
                    <li>{`Minimum purchase of ${currencyView}${data.minPurchase.amount} required to redeem the reward`}</li>
                  )}
                  {data?.terms.map((term, i) => (
                    <li key={i}>{term?.text}</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
      </div>
      <ShareModal
        isOpen={isCustomShare}
        storeName={data.storeName}
        landingPageTitle={data.landingPageTitle}
        toggleCanvas={() => toggleCustomShare(!isCustomShare)}
        shortlink={getReferredShortLink(data.referred_short_link_code)}
      />
    </div>
  );
};

export default FinalExistingB2cLp;

const getNewCustRewardTitle = (reward, currencyView) => {
  if (reward?.type === "amount_off")
    return `${currencyView}${reward?.amount_off} discount`;
  else if (reward?.type === "percentage_off")
    return `${reward?.percentage_off}% discount`;

  return reward?.items?.length
    ? `free ${reward?.items?.map((item) => item.name)?.join(",")}`
    : reward?.combo
    ? `free items`
    : `a free item`;
};

const getReferredShortLink = (code) =>
  import.meta.env.VITE_CUSTOM_NODE_ENV === "production"
    ? `http://r.reelo.io/${code}`
    : import.meta.env.VITE_CUSTOM_NODE_ENV === "staging"
    ? `http://rs.reelo.io/${code}`
    : `http://rd.reelo.io/${code}`;
